module.exports = __webpack_public_path__ + "static/media/comando.00cf7b33.png";